// Số chưa đọc + nghe socket `notification:new` (room user:<username> — server join khi JWT hợp lệ).
// Refetch khi mount / focus tab / reconnect: script chạy tay dùng socket port khác nên không phát realtime.
import { useCallback, useEffect, useRef, useState } from 'react'
import { socket } from 'socket'
import { getUnreadCount } from 'apis/notifications'

export default function useNotificationFeed() {
  const [counts, setCounts] = useState({ count: 0, action: 0 })
  const [latest, setLatest] = useState(null) // thông báo mới nhất nhận qua socket (để popover chèn đầu list)
  const seen = useRef(new Set())

  const refresh = useCallback(async () => {
    try {
      const res = await getUnreadCount()
      if (res.status === 200 && res.data.success) setCounts({ count: res.data.count || 0, action: res.data.action || 0 })
    } catch (e) {}
  }, [])

  useEffect(() => {
    refresh()
    const onNew = (doc) => {
      if (!doc || !doc._id || seen.current.has(doc._id)) return
      seen.current.add(doc._id)
      setLatest(doc)
      setCounts((c) => ({
        count: c.count + 1,
        action: c.action + (['push_held', 'push_error', 'design_blocked'].includes(doc.type) ? 1 : 0),
      }))
    }
    const onFocus = () => refresh()
    socket.on('notification:new', onNew)
    socket.on('connect', refresh)
    window.addEventListener('focus', onFocus)
    return () => {
      socket.off('notification:new', onNew)
      socket.off('connect', refresh)
      window.removeEventListener('focus', onFocus)
    }
  }, [refresh])

  return { counts, latest, refresh }
}
